import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditTemplatePayload {
    id: string
    data: any
    sagaCB?: {
        onSuccess: any
        onError?: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editTemplate = createSlice({
    name: 'template/edit-template',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IEditTemplatePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editTemplateActions = editTemplate.actions
export default editTemplate.reducer
